import { FC } from "react";
import { Select } from "../../../../components/Common";
import { useFormik } from "formik";
import * as Yup from "yup";
import { useOperatorOptions } from "./operator-options";
import { Col, Container, Form, Row } from "reactstrap";

interface Props {
    id: string;
    value?: number;
    onSubmit: (_form: OperatorFormValues) => void;
}

export interface OperatorFormValues {
    operatorId?: number;
}

const OperatorForm: FC<Props> = ({ id, value, onSubmit }) => {
    const { options, isLoading } = useOperatorOptions();

    const form = useFormik<OperatorFormValues>({
        initialValues: {
            operatorId: value == null ? undefined : value,
        },
        validationSchema: Yup.object({}),
        validateOnMount: true,
        validateOnChange: true,
        onSubmit,
    });

    return (
        <Form
            id={id}
            onSubmit={e => {
                e.preventDefault();
                form.handleSubmit();
                return false;
            }}
        >
            <Container fluid className="px-0 mt-2">
                <Row>
                    <Col>
                        <Select
                            name="operatorId"
                            placeholder={isLoading ? "Loading operators list...": "Select Operator"}
                            options={options}
                            value = {
                                options.filter(option =>
                                    option.value === form.values.operatorId)
                            }
                            formik={form}
                            isDisabled={isLoading}
                        ></Select>
                    </Col>
                </Row>
                <Row>
                    <Col className="d-flex justify-content-end">
                        <a
                            role="button"
                            type="submit"
                            className="text-primary mt-2"
                            onClick={() => { form.handleSubmit(); }}
                        >
                            Assign
                        </a>
                    </Col>
                </Row>
            </Container>
        </Form>
    );
};

export default OperatorForm;
